import {
    Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay
} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import {toEnglishNumber} from "../utils/numberConversion";
import {setIn} from "formik";

function DiscountModal({isOpen, onClose, setRefresh}) {
    const [code, setCode] = useState("");
    const [count, setCount] = useState("");
    const [products, setProducts] = useState([]);
    const [index, setIndex] = useState(0);
    const [productId, setProductId] = useState(0);
    const [productType, setProductType] = useState(0);
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        const updatePorducts = async () => {
            try {
                const response = await api.get('/api/products')
                setProducts(response.data.data);
            } catch (error) {
            } finally {
            }
        }
        updatePorducts()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(productId)
        if (code === "" || percentage === 0 || productId === "" || count === "") {
            toast.error("فرم را به درستی کامل کنید!", {
                position: "bottom-right"
            });
            return;
        }
        try {
            const response = await api.post('/api/discount', {
                code: code,
                count: toEnglishNumber(count),
                product_id: productId,
                product_type: productType,
                discount_amount: percentage,
                status: false
            });
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            onClose();
            setRefresh(true)
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    return (<Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
            <ModalHeader>افزودن کد تخفیف</ModalHeader>
            <ModalCloseButton/>
            <ModalBody className="exam-modal">
                <form className={"d-flex flex-column gap-1"} onSubmit={handleSubmit}>
                    <div className={"custom-input-group"}>
                        <label>کد تخفیف</label>
                        <input className={`form-control`} placeholder={"کد تخفیف(انگلیسی و اعداد)"}
                               value={code} onChange={(e) => setCode(e.target.value)}/>
                    </div>
                    <div className={"custom-input-group"}>
                        <label>محصول</label>
                        <select className={"form-control"}
                                value={index} onChange={(e) => {
                            const value = e.target.value - 1;
                            setIndex(value + 1)
                            if (e.target.value != 0) {
                                setProductId(products[value].id)
                                setProductType(products[value].product_type)
                            }
                        }}>
                            <option value={0} key={0}>همه محصولات</option>
                            {products.length > 0 && products.map((product, index) => {
                                return (<option key={index + 1} value={index + 1}>{product.name}</option>)
                            })}
                        </select>
                    </div>
                    <div className={"custom-input-group"}>
                        <label>درصد تخفیف</label>
                        <input className={`form-control`} placeholder={"78"}
                               value={percentage} onChange={(e) => {
                            const value = parseInt(e.target.value);
                            if (value > 100)
                                setPercentage(100);
                            else if (value < 0)
                                setPercentage(0)
                            else
                                setPercentage(value)
                        }}/>
                    </div>
                    <div className={"custom-input-group"}>
                        <label>تعداد</label>
                        <input className={`form-control`} placeholder={"1"}
                               value={count} onChange={(e) => {
                            setCount(e.target.value)
                        }}/>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                    بستن
                </Button>
                <Button colorScheme='green' onClick={handleSubmit}>ثبت</Button>
            </ModalFooter>
        </ModalContent>
    </Modal>)
}

export default DiscountModal;